/* eslint-disable no-return-assign */
import { useEffect, useRef } from 'react';
import './styles.css';
import DokanListIcons from '../icon/DokanListIcons';

function Modal({ title = '', onClose, show, footer = null, children }) {
    const modal = useRef(null);

    // const handleBack = (event) => {
    //   console.log("event", modal.current.contains(event.target));
    //   if (modal.current) {
    //     if (!modal.current.contains(event.target)) {
    //       onClose();
    //     }
    //     modal.current.style.visibility = "hidden";
    //   }
    // };
    // useEffect(() => {
    //   document.addEventListener("click", handleBack, true);
    //   return () => {
    //     document.removeEventListener("click", handleBack, true);
    //   };
    // }, []);

    useEffect(() => {
        if (show) {
            return (modal.current.style.visibility = 'visible');
        }
        return (modal.current.style.visibility = 'hidden');
    }, [show]);
    return (
        <>
            <div
                className="modal"
                onClick={() => {
                    onClose();
                }}
                ref={modal}
                role="button"
                tabIndex="0"
            >
                <div className="modal-wrapper animate">
                    <div
                        className="modal-body"
                        onClick={(e) => {
                            // do not close modal if anything inside modal content is clicked
                            e.stopPropagation();
                        }}
                        role="button"
                        tabIndex="0"
                    >
                        {/** modal header */}
                        <div className="modal-header">
                            <div className="modal-title">{title}</div>
                            <div
                                className="modal-close-button p-2 hover:bg-gray-400"
                                onClick={onClose}
                                role="button"
                                tabIndex="0"
                            >
                                {/* &#10006; */}
                                <DokanListIcons icon="cross" size={14} />
                            </div>
                        </div>
                        {/** modal body */}
                        <div className="modal-content">{children}</div>
                        <div className="footer">
                            <div>{footer}</div>
                            {/* <div>
                                <button type="button" className="btn btn-cancel">
                                    Cancel
                                </button>
                            </div> */}
                            {/* <div>
                                <button type="button" className="btn btn-ok">
                                    Submit
                                </button>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Modal;
